import React from "react";
import _ from "lodash";

import TwrSettingsIndex from "./settings";
import ProjectTwrCategoriesRoutes from "modules/project/twr/categories/web/routes";
import ProjectTwrEsmCategoriesRoutes from "modules/project/twr/esm_categories/web/routes";

let routes = [
  {
    path: "/project/twr/settings",
    component: TwrSettingsIndex,
    name: "TWR Settings",
  },
];

routes = _.concat(routes, ProjectTwrCategoriesRoutes);
routes = _.concat(routes, ProjectTwrEsmCategoriesRoutes);

export default routes;
